const { getRouteStatusLabel } = require('react/utils/routeUtils');


Monet.Grid = {
    formatDataFromCollection: function (columns, collection, entity) {
        const isArray = function (object) {
            return object instanceof Array;
        }

        const getInfo = function(object, fields) {
            return object.map((item) => (item[fields[fields.length - 1]]));
        }

        var getValue = function (model, column) {

            var fields = (column.field) ? column.field.split(".") : [];

            if (column.fieldInformation) {
                const meta = column.fieldInformation.meta;
                const json = meta && typeof meta === 'string' ? JSON.parse(meta) : meta;
                const lookupEntityColumn = column.fieldInformation.lookupEntityColumn;
                let collection = null;

                if (json?.hasMany) {
                    const collectionName = json.hasMany.collectionName || column.fieldInformation.name;
                    if (collectionName === fields[0] && model[fields[0]]) {
                        collection = model[fields[0]];
                    } else if (collectionName === fields[0] + '.' + fields[1] && model[fields[0]] && model[fields[0]][fields[1]]) {
                        collection = model[fields[0]][fields[1]];
                    }
                }

                // TODO: improve "entityColumn" name and use (GMM-1142)
                if (collection && json.hasMany.entityColumn) {
                    if(isArray(collection)) {
                        return collection.map((item) => {
                            const objectEntityName = item[json.hasMany.entityName];
                            const objectLookupEntityColumn = objectEntityName !== undefined ? objectEntityName[json.hasMany.lookupEntityColumn] : undefined;
                            return objectLookupEntityColumn !== undefined && isArray(objectLookupEntityColumn) ? getInfo(objectLookupEntityColumn, fields) : objectLookupEntityColumn;
                        }).join(", ");
                    } else {
                        const objectEntityName = collection[json.hasMany.entityName];
                        return objectEntityName !== undefined && isArray(objectEntityName) ? getInfo(objectEntityName, fields).join(", ") : objectEntityName;
                    }
                } else if (collection && json?.hasMany?.entityName) {
                    return collection.map((item) => (
                      item[json.hasMany.entityName][fields[fields.length - 1]]
                    )).join(", ");
                } else if (lookupEntityColumn) {
                    const entityName = fields[0];
                    collection = model[entityName];

                    if (collection && collection.map) {
                        return collection.map((item) => (
                            item[lookupEntityColumn]
                        )).join(", ");
                    }
                }
            }

            return fields.reduce(function (object, name) {
                if (object && name) {
                    return object[name];
                }
            }, model);
        };

        var models = collection ? collection.models : [];

        const formattedData = [];

        models.forEach((model) => {
            if (entity === 'Task' && model.attributes && model.attributes.description) {
                model.attributes.description = model.attributes.description.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
            }
            const id = model.id ? model.attributes.id : model.cid;
            const obj = {
                id: entity + "_" + id,
                idOfObject: id,
                model: model
            };
            columns.forEach((column) => {
                let value = getValue(model.attributes, column);
                if (column.fieldInformation &&
                    column.fieldInformation.fieldDomains &&
                    column.fieldInformation.fieldDomains.length) {
                    value = column.fieldInformation.fieldDomains
                        .reduce((previous, current) => {
                            if (current.value === previous) {
                                previous = current.description;
                            }
                            return previous;
                        }, value);
                }
                obj[column.field] = value;
            });
            formattedData.push(obj);
        });
        return formattedData;
    },

    formatDataSimple: function (columns, collection, entity) {

        const getValue = function (model, column) {

            const fields = (column.field) ? column.field.split(".") : [];

            return fields.reduce(function (object, name) {
                if (object && name) {
                    return object[name];
                }
            }, model);
        };

        const models = collection.models.map(item => {
            return item.attributes;
        });

        return models.map(function (model) {
            const id = model.optimizationId;
            const obj = {
                id: entity + "_" + id,
                idOfObject: id,
                model: model
            };

            columns.forEach(function (column) {
                var value = getValue(model, column);

                if (column.fieldInformation &&
                    column.fieldInformation.fieldDomains &&
                    column.fieldInformation.fieldDomains.length) {

                    value = column.fieldInformation.fieldDomains
                        .reduce(function (previous, current) {
                            if (current.value === previous) {
                                previous = current.description;
                            }
                            return previous;
                        }, value);

                }

                obj[column.field] = Monet.I18n.getResourcesByKey(value);

            }, this);

            return obj;
        }, this);
    },

    addDataToGridWithOptionsNoPagination: function (entity, tableLayout, data, options) {
        var error = null;

        if (!options) {
            error = new Monet.Exception.ReturnError(this,
                "No options informed. If you dont have options, please use addDataToGrid function");
            error.console();
        }

        var resultArrayFormated = [],
            grid = options.grid,
            dataView = options.dataView;

        try {

            if (grid) {
                dataView.arrayIds = [];
                dataView.beginUpdate();
                resultArrayFormated = Monet.Grid.formatDataFromCollection(
                    tableLayout, data, dataView.entity);

                dataView.setData(resultArrayFormated);
                Monet.Grid.Utils.hideGridNoResult(entity);

                if (!resultArrayFormated.length) {
                    Monet.Grid.Utils.showGridNoResult(entity);

                }

                dataView.endUpdate();
                grid.scrollRowToTop(0);
                grid.updateRowCount();
                grid.invalidate();
            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on add data to grid", e);
            error.console();
        }
    },

    addDataToGrid: function (entity, tableLayout, data, addPagination, options) {

        var resultArrayFormated = [],
            grid = null,
            dataView = null,
            error = null,
            controlUpdater = null,
            collection = data;

        try {

            controlUpdater = App.Forms[entity].controlUpdater;

            if (typeof (App.Forms[entity].table) !== "undefined") {

                if (controlUpdater && collection.size()) {

                    controlUpdater.initialPage(entity, 0);

                }

                Monet.Grid.Utils.updatePaginationOptions(entity, collection.size());

                grid = App.Forms[entity].table;
                dataView = App.Forms[entity].dataProvider;
                dataView.arrayIds = [];

                dataView.beginUpdate();

                if (options && options.blockFormatData) {
                    resultArrayFormated = Monet.Grid.formatDataSimple(tableLayout, collection, dataView.entity);
                } else {
                    resultArrayFormated = Monet.Grid.formatDataFromCollection(
                        tableLayout, collection, dataView.entity);
                }

                dataView.setData(resultArrayFormated);

                Monet.Grid.Utils.hideGridNoResult(entity);

                if (!resultArrayFormated.length) {
                    Monet.Grid.Utils.showGridNoResult(entity);
                }

                dataView.endUpdate();
                if (!options || options.scrollRowToTop) {
                    grid.scrollRowToTop(0);
                }
                grid.updateRowCount();
                grid.invalidate();

                if (addPagination) {
                    grid.addScrollToGrid();
                }

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on add data to grid", e);
            error.console();
        }

    },

    appendDataToGrid: function (entity, tableLayout, data) {
        var resultArrayFormatedLength = 0,
            resultArrayFormated = [],
            grid = null,
            dataView = null,
            error = null,
            sortBy,
            id = 0,
            gridParentNode,
            loading;

        try {

            loading = new Monet.UI.LoadingData();
            grid = App.Forms[entity].table;

            if (grid) {
                gridParentNode = grid.getContainerNode();
                loading.setContainerToAppend(gridParentNode);
                loading.init();
                dataView = grid.getData();

                if (data.models.length > 0) {

                    grid.removeScrollToGrid();
                    dataView.beginUpdate();

                    resultArrayFormated = Monet.Grid.formatDataFromCollection(
                        tableLayout, data, entity);

                    resultArrayFormatedLength = resultArrayFormated.length;

                    for (var i = 0; i < resultArrayFormatedLength; i++) {

                        id = resultArrayFormated[i].idOfObject;

                        if (id !== 0 && dataView.arrayIds.indexOf(id) === -1) {
                            dataView.addItem(resultArrayFormated[i]);
                            dataView.arrayIds.push(id);
                        }

                    }

                    dataView.endUpdate();

                    sortBy = grid.getOptions().sortBy;

                    if (sortBy === 'client') {

                        grid.setSortColumns(grid.getSortColumns());
                        dataView.reSort();

                    }

                    grid.invalidate();

                }
                loading.hide();

                grid.addScrollToGrid();
            }
        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on append data to grid", e);
            error.console();
        }

    },

    appendDataToGridAfterPagination: function (entity, tableLayout, collection) {

        var grid = null,
            dataView = null,
            error = null,
            pagination = null,
            controlUpdater = null,
            sortBy,
            id = 0,
            gridParentNode,
            loading;

        try {

            loading = new Monet.UI.LoadingData();
            grid = App.Forms[entity].table;

            if (grid) {
                gridParentNode = grid.getContainerNode();
                loading.setContainerToAppend(gridParentNode);
                loading.init();

                dataView = grid.getData();
                pagination = App.Forms[entity].pagination;

                controlUpdater = App.Forms[entity].controlUpdater;

                pagination.blocked = true;

                if (collection.size() > 0) {

                    const updatePaginationOptions = () => {
                        pagination.first = dataView.data.length;
                        pagination.canIncrement = false;
                    };

                    grid.removeScrollToGrid();

                    if (controlUpdater) {

                        controlUpdater.addPageToControlUpdate(entity, pagination.first);

                    }

                    dataView.beginUpdate();

                    Monet.Grid
                        .formatDataFromCollection(tableLayout, collection, entity)
                        .forEach(result => {
                            const addNewItensAvoidingDuplicated = () => {
                                id = result.idOfObject;
                                if (id !== 0 && dataView.arrayIds.indexOf(id) === -1) {
                                    dataView.addItem(result);
                                    dataView.arrayIds.push(id);
                                }
                            };

                            addNewItensAvoidingDuplicated();
                        });

                    updatePaginationOptions();

                    dataView.endUpdate();

                    sortBy = grid.getOptions().sortBy;

                    if (sortBy === 'client') {

                        grid.setSortColumns(grid.getSortColumns());
                        dataView.reSort();

                    }

                    grid.invalidate();

                }

                pagination.blocked = false;

                loading.hide();

                grid.addScrollToGrid();

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on append data to grid", e);
            error.console();
        }

    },

    getGridLayout: function (pageLayout, entity) {

        var keys = [],
            name = "",
            layoutItem = null;
        if (pageLayout) {

            $.each(pageLayout.sections, function (index, section) {
                if (section.sectionRelatedLists !== undefined && section.sectionRelatedLists.length > 0) {

                    $.each(section.sectionRelatedLists, function (index, relatedList) {
                        $.each(relatedList.searchGridLayout.searchGridColumns, function (index, column) {

                            if (column && column.field) {

                                var addMenuToColumn = function () {

                                    var menu = null,
                                        monetGridUtils = Monet.Grid.Utils,
                                        meta = column.field.meta,
                                        notStatistics = false;

                                    if (meta) {
                                        if (typeof meta === "string") {
                                            meta = JSON.parse(meta);
                                        }

                                        if (meta.notStatistics) {
                                            notStatistics = true;
                                        }
                                    }

                                    if (monetGridUtils.fieldCanHaveTotal(column.field.type) && !notStatistics) {
                                        menu = {
                                            menu: {
                                                items: [
                                                    {
                                                        iconImage: require('static/images/jstreew/throbber.gif'),
                                                        title: Monet.I18n.getResourcesByKey("Greenmile.grid.showTotals.loadingData")
                                                    }
                                                ]
                                            }
                                        };
                                    }

                                    return menu;

                                };


                                if (typeof column.field.lookupEntityColumn !== "undefined") {

                                    name = column.field.name + "." + column.field.lookupEntityColumn;

                                } else {

                                    name = column.field.name;

                                }

                                var sortable = true;

                                if ((relatedList.searchGridLayout.entity.key === "AutoArriveLog" && column.field.name === 'message')
                                    || relatedList.searchGridLayout.entity.key === "RouteActionsConfiguration") {
                                    sortable = false;
                                }

                                const notAllowedSortableColumns = [
                                    'totalOpenEventLogs',
                                    'secondaryAssignments.equipment'
                                ];

                                if (notAllowedSortableColumns.includes(column.field.name)) {
                                    sortable = false;
                                }

                                layoutItem = {
                                    id: column.field.id,
                                    name: Monet.I18n.getResourcesByKey(column.field.label),
                                    field: name,
                                    width: column.sizePixels,
                                    cssClass: "cell-row",
                                    sortable: sortable,
                                    resizable: true,
                                    fieldId: column.field.id,
                                    fieldInformation: column.field,
                                    entity: relatedList.searchGridLayout.entity.key,
                                    header: addMenuToColumn(),
                                    formatter: Monet.FormBuilder.FormatterGridColumn
                                };

                                if (entity) {

                                    layoutItem.entity = entity;

                                }

                                if (!Monet.Grid.blackList(layoutItem.field)) {
                                    keys.push(layoutItem);
                                }

                            }

                        });
                    });
                }

            });


        }
        return keys;

    },

    hasPermission: (entity, permissionName) => {
        const permissions = Monet.Session.Security.permissions;
        return !!permissions.find(permission => permission.key === `${entity}_${permissionName}`.toUpperCase());
    },

    generateSearchGridLayout: function (entity, { layoutNamespace, kind, defaultColumns, customActions } = {}) {
        const fields = App.Forms[entity].fields || {};

        const getGridActions = () => {
            const actions = [];
            this.hasPermission(entity, 'UPDATE') && actions.push({ name: 'btn_edit' });
            (this.hasPermission(entity, 'DELETE') || this.hasPermission(entity, 'REMOVE')) && actions.push({ name: 'btn_delete' });

            if (customActions?.length) {
                customActions.forEach( action => {
                    actions.push(action);
                });
            }

            return actions;
        };

        const getSearchGridColumns = () => {
            layoutNamespace = layoutNamespace || entity;
            const customGridColumns = JSON.parse(localStorage.getItem('customGridColumns') || null);
            if (customGridColumns && customGridColumns[layoutNamespace] && customGridColumns[layoutNamespace][Monet.Session.User.id]) {
                return customGridColumns[layoutNamespace][Monet.Session.User.id].map((column) => ({
                    ...column,
                    field: Object.values(fields).find(field => column.field.id === field.id)
                }));
            } else {
                localStorage.setItem('customGridColumns', JSON.stringify(customGridColumns || {}));
                const initialFields = (defaultColumns && defaultColumns.length) ? (
                    defaultColumns.map((fieldName) => fields[fieldName])
                ) : Object.values(fields);
                return initialFields.map((field, index) => ({
                    columnOrder: index + 1,
                    isSorted: false,
                    isAscendent: true,
                    isFrozen: false,
                    sizePixels: 200,
                    field: { id: index, ...field }
                }));
            }
        };

        return {
            entity: {
                key: entity
            },
            description: entity,
            kind: kind || 'DETAILED',
            searchGridActions: getGridActions(),
            searchGridColumns: getSearchGridColumns()
        };
    },

    generateIndexLayout: function (entity, tabName, gridOptions = {}) {
        const getSectionButtons = () => {
            return this.hasPermission(entity, 'CREATE') ? [{
                customJavaScript: `window.location = '#/${entity.charAt(0).toUpperCase() + entity.slice(1)}/new';`,
                customLabel: "default.button.new"
            }] : [];
        }

        App.Forms[entity].layout = {};
        App.Forms[entity].layout.index = {
            userInterfaceAction: {
                userInterface: {
                    key: entity,
                    description: tabName
                },
                key: "index"
            },
            sections: [
                {
                    description: tabName,
                    key: "pls_index_btn_"  + entity.toLowerCase(),
                    layoutColumns: 1,
                    layoutOrder: 1,
                    sectionRelatedLists: [],
                    sectionFields: [],
                    sectionButtons: getSectionButtons()
                },
                {
                    key: "pls_index_grid_" + entity.toLowerCase(),
                    description: "",
                    layoutColumns: 1,
                    layoutOrder: 1,
                    sectionRelatedLists: [
                        {
                            searchGridLayout: this.generateSearchGridLayout(entity, gridOptions),
                            sectionOrder: 1
                        }
                    ],
                    sectionFields: [],
                    sectionButtons: []
                }
            ]
        };
    },

    /**
     * Retorna o índice d coluna congelada
     * @param pageLayout
     */

    getIndexFrozenColumn: function (pageLayout) {

        const sections = pageLayout ? pageLayout.sections : [];
        let columnFrozen = -1;


        for (var i = 0; i < sections.length; i++) {

            var section = sections[i];
            var relatedList = section.sectionRelatedLists;

            if (relatedList) {

                for (var j = 0; j < relatedList.length; j++) {

                    if (relatedList[j].searchGridLayout) {

                        var searchGridColumns = relatedList[j].searchGridLayout.searchGridColumns;

                        if (searchGridColumns) {

                            for (var k = 0; k < searchGridColumns.length; k++) {

                                var column = searchGridColumns[k];

                                if (!column.isFrozen) {

                                    break;

                                }

                                columnFrozen = k;

                            }

                        }

                    }

                }

            }

        }

        return columnFrozen;


    },

    /*
     * Cria um data mapper como base na tela de index, essa função não retorna nada, o mapa
     * será armazenado no nameSpace padrão de mapas App.Form.<entity>.dataMapper
     *
     *  @params {object} pageLayoutData : É o objeto com o page layout
     *  @params {function} callBack : É a função que será executada ao final dessa
     *  @params {string} entity : É a interface que será chamada para obter o layout a fim de fazer o dataMapper
     */

    createDataMapper: function (callback, pageLayoutData, entity) {

        var pageLayout;

        var generateMap = function (pageLayout) {

            pageLayout.createDataMapper(entity);

            if (typeof (callback) !== "undefined") {
                callback(pageLayout);
            }
        };

        if (typeof (pageLayoutData) === "undefined") {

            pageLayout = new App.Collections.PageLayout();

            pageLayout.setService(entity);
            pageLayout.setAction("new");

            pageLayout.fetch({
                success: function (pageLayout) {

                    generateMap(pageLayout);

                }
            });

        } else {

            pageLayout = pageLayoutData;

            generateMap();

        }

    }
};

Monet.Grid.Utils = {

    getFilterToSearch: function (entity, selectorSearchField) {

        try {

            var x = "",
                valueOfField = "",
                hasKey = false,
                hasDescription = false,
                hasOrganization = false,
                hasName = false,
                isSuperGrid = true;

            if (typeof entity !== "undefined") {

                if (typeof selectorSearchField !== "undefined") {

                    var valor = $(selectorSearchField).val();

                    if (valor) {

                        valueOfField = valor;
                    }
                }

                isSuperGrid = Monet.Grid.Utils.isSuperGrid(entity);

                if (isSuperGrid) {

                    x = "%" + valueOfField + "%";

                } else {

                    for (var i in App.Forms[entity].dataMapper) {

                        if (i === "key") {
                            hasKey = true;
                        }

                        if (i === "description") {
                            hasDescription = true;
                        }

                        if (i === "organization") {
                            hasOrganization = true;
                        }

                        if (i === "name") {
                            hasName = true;
                        }
                    }

                    if (hasName) {
                        x = '{"name": "%' + valueOfField + '%"}';
                    } else {
                        if (hasKey) {
                            x = '{"key": "%' + valueOfField + '%"}';
                        } else {
                            if (hasDescription) {
                                x = '{"description": "%' + valueOfField + '%"}';
                            } else {
                                x = '{"organization": {"description":"%' + valueOfField + '%" }}';
                            }
                        }
                    }

                }

                return x;

            } else {
                error = new Monet.Exception.ReturnError(this,
                    "No entity on get filter to search on grid.");
                error.console();
            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on get filter to search on grid.");
            error.console();

        }
    },

    isSuperGrid: function (entity) {

        var superGrids = false;

        if (typeof (App.Forms[entity]) === "undefined") {

            superGrids = true;

        }

        return superGrids;

    },

    formatOrdersToProjection: function (columnsToOrders) {

        var orders = '',
            objectOrders = [],
            columnsToOrderLength = 0;

        if (typeof (columnsToOrders) !== "undefined") {

            columnsToOrderLength = columnsToOrders.length;

            for (var i = 0; i < columnsToOrderLength; i++) {

                column = columnsToOrders[i];

                objectOrders.push({ "attr": column.field, "type": column.order });

            }

            orders = '"orders":' + JSON.stringify(objectOrders);

        }

        return orders;

    },

    formatOrdersToRestriction: function (columnsToOrders) {

        var orders = [],
            columnsToOrderLength = 0,
            column = null;

        if (columnsToOrders) {

            columnsToOrderLength = columnsToOrders.length;

            for (var i = 0; i < columnsToOrderLength; i++) {

                column = columnsToOrders[i];

                orders.push({ "attr": column.field, "type": column.order });

            }

        }

        return orders;

    },

    updatePaginationOptions: function (entity, dataLength) {

        var error = null,
            pagination = null;

        try {

            pagination = App.Forms[entity].pagination;

            if (pagination) {

                pagination.canIncrement = true;

                if (dataLength > 0 && dataLength < pagination.max) {
                    pagination.first += dataLength + 1;
                    pagination.canIncrement = false;
                }

            }

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on update pagination options", e);
            error.console();
        }

    },

    formatBooleanValue: function (booleanValue, imageName) {

        var error = null,
            html = "",
            image = imageName || { imgTrue: '<div class="gridCheckboxTrue"></div>', imgFalse: '<div class="gridCheckboxFalse"></div>' };

        try {

            if (!booleanValue) {

                html = image.imgFalse;

            } else {

                html = image.imgTrue;

            }

            return html;

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                "Error on format boolean value.");
            error.console();
        }

    },

    paginationOptions: {
        FIRST: 0,
        MAX_RESULT: 51,
        NUMBER_INCREMENT: 51
    },

    getIndexColumnFrozen: function (sectionRelatedLists) {

        var error = null,
            pageLayoutLength = 0,
            index = -1;

        try {

            if (typeof sectionRelatedLists !== "undefined") {

                const searchGridColumns = sectionRelatedLists[0].searchGridLayout.searchGridColumns;

                pageLayoutLength = searchGridColumns.length;

                for (var i = 0; i < pageLayoutLength; i++) {

                    var column = searchGridColumns[i];

                    if (!column.isFrozen) {
                        index = i - 1;
                        break;
                    }

                }

            }

            return index;

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on get inde columns frozen.", e);
            error.console();

        }
    },

    fieldCanHaveTotal: function (fieldType) {

        var error = null;

        try {


            switch (fieldType) {
                case "INT":
                case "INTEGER":
                case "DECIMAL":
                case "DISTANCE":
                case "MILLISECONDS":
                case "MILES_OR_METERS":
                    return true;
                default:
                    return false;
            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                "Error on field can have total");
            error.console();

        }
    },
    clearPagination: function (entity) {
        if (entity) {
            const form = App.Forms[entity];
            if (form) {
                const { FIRST, MAX_RESULT } = Monet.Grid.Utils.paginationOptions;
                App.Forms[entity].pagination = {
                    first: FIRST,
                    max: MAX_RESULT
                };
            }
        }
    },
    showGridNoResult: function (entity) {

        const keyNoResult = 'Greenmile.Grid.NoResult';
        const table = App.Forms[entity].table;
        const grid = table.getContainerNode();
        const viewport = table.getViewportNode();

        if (grid && viewport) {
            const noResultContainer = document.createElement('div');
            noResultContainer.className = 'noResultContainer';
            noResultContainer.innerHTML = Monet.I18n.getResourcesByKey(keyNoResult);
            grid.appendChild(noResultContainer);
        }

    },

    hideGridNoResult: function (entity) {

        const table = App.Forms[entity].table;
        const grid = table.getContainerNode();
        const viewport = table.getViewportNode();
        const noResultContainer = grid && grid.querySelector('div.noResultContainer');

        if (noResultContainer && grid && viewport) {
            grid.removeChild(noResultContainer);
        }

    },
    //TODO Mover para dentro dos router ou classe mais específica
    getStatusRoute: function (routeStatus) {
      return getRouteStatusLabel(routeStatus);
    },

    getTagType: function (tagType) {

        let _tagType;

        switch (tagType) {

            case 'ROUTE':
                _tagType = Monet.I18n.getResourcesByKey('Filter.Route.status.notStarted');
                break;
            case 'EQUIPMENT':
                _tagType = Monet.I18n.getResourcesByKey('Filter.Route.status.started');
                break;
            case 'GEOFENCE':
                _tagType = Monet.I18n.getResourcesByKey('Filter.Route.status.departedOrigin');
                break;
            default:
                _tagType = Monet.I18n.getResourcesByKey('Filter.Route.status.notStarted');

        }

        return _tagType;

    },

    getStatusLogType: function (logTypeStatus) {

        var _logTypeStatus;

        switch (logTypeStatus) {

            case 'ROUTE_NOT_FOUND':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.routeNotFound');
                break;
            case 'ROUTE_STARTED':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.routeStarted');
                break;
            case 'ROUTE_FINISH_CANDIDATE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.routeFinishCandidate');
                break;
            case 'ROUTE_FINISH_CANCELED':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.routeFinishCanceled');
                break;
            case 'ARRIVE_STOP_CANDIDATE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.arriveStopCandidate');
                break;
            case 'ARRIVE_STOP_CANDIDATE_CANCELED':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.arriveStopCandCanceled');
                break;
            case 'ARRIVE_STOP':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.arriveStop');
                break;
            case 'DEPART_STOP':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.departStop');
                break;
            case 'CANCEL_STOP':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.cancelStop');
                break;
            case 'COMPLETE_ROUTE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.completeRoute');
                break;
            case 'BULK_ARRIVE_CANDIDATE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.bulkArriveCandidate');
                break;
            case 'PINGS_OUT_OF_SEQUENCE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.pingsOutOfSequence');
                break;
            case 'ERROR_START_ROUTE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.errorStartRoute');
                break;
            case 'STOP_ALREADY_ARRIVED':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.stopAlreadyArrived');
                break;
            case 'STOP_ALREADY_DEPARTED':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.stopAlreadyDeparted');
                break;
            case 'DISCARTED_CANDIDATE':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.discartedCandidate');
                break;
            case 'DEPART_ORIGIN':
                _logTypeStatus = Monet.I18n.getResourcesByKey('autoarrivelog.logType.departOrigin');
                break;
            default:
                _logTypeStatus = '';

        }

        return _logTypeStatus;

    },

    removeSortableOfColumns: function (columns) {

        var total = columns.length;

        for (var i = 0; i < total; i++) {

            columns[i].sortable = false;

        }

        return columns;

    },

    getMenusEnabledFromGridLayout: function (layout) {

        const menu = [];
        if (layout) {
            var sections = layout.sections;
            var sectionsLength = sections.length;

            for (var i = 0; i < sectionsLength; i++) {

                var relatedLists = sections[i].sectionRelatedLists;
                var relatedListsLength = relatedLists.length;

                for (var j = 0; j < relatedListsLength; j++) {

                    var relatedList = relatedLists[j];
                    var searchGridLayout = relatedList.searchGridLayout;
                    var searchGridActions = searchGridLayout.searchGridActions;
                    var searchGridActionsLentgh = searchGridActions.length;

                    for (var k = 0; k < searchGridActionsLentgh; k++) {

                        var gridActions = searchGridActions[k];

                        menu.push(gridActions.name);

                    }

                }

            }
        }
        return menu;
    },
};

// Essa função some com algumas colunas problemáticas
// ela deve ser eliminada do sistema assim que o server
// arrumar uma forma genérica de lidar com colunas calculadas

Monet.Grid.blackList = function (fieldName) {

    switch (fieldName) {
        case 'plannedServiceTime':
        case 'baselineServiceTime':
        case 'driversName':
        case 'principalEquipment':
        case 'actualServiceTime':
        case 'groups':
        case 'organizations.organization':
        case 'instructions':
        case 'stops.location.description':
        case 'stops.location.key':
        case 'calculatedVariableRatePercetage':
        case 'calculatedFixedRatePercetage':
        case 'largeDeliveryPriorization':
        case 'prioritizeStopWithVolume':
        case 'largeDeliveryPriorizationType':
        case 'lineItems.sku':
        case 'orders.lineItems.sku':
        case 'route.stops.orders.salesMan':
        case 'stop.orders.salesMan':
            return true;
        default:
            return false;
    }

};
